/**
 * Single source of truth for rendering an `expiry_type` value as a chip / badge.
 *
 * Used by StrategyCard, StrategyTable, StrategyRowView, schedule tables, and
 * the marketplace listing surfaces so the four sites stay aligned and the
 * chip never accidentally renders the underscore form ("NEXT_WEEKLY") to users.
 */
import { EXPIRY_TYPE_CONST } from '../../constants/tradingConstants';

export const expiryTypeLabel = (t: string | null | undefined): string => {
  switch ((t || '').toLowerCase()) {
    case EXPIRY_TYPE_CONST.WEEKLY:
      return 'WEEKLY';
    case EXPIRY_TYPE_CONST.NEXT_WEEKLY:
      return 'NEXT WEEKLY';
    case EXPIRY_TYPE_CONST.MONTHLY:
      return 'MONTHLY';
    case EXPIRY_TYPE_CONST.NEXT_MONTHLY:
      return 'NEXT MONTHLY';
    default:
      return (t || '').toUpperCase();
  }
};
